// extracted by mini-css-extract-plugin
export default {"tr":"TempSJA_tr__GhNdn"};